<template>
    <footer class="statusbar">
        <div class="left">Zoom {{ zoom * 100 }}% • Grid 40px</div>
        <div class="right">X: {{ Math.round(axis.x / zoom) }}, Y: {{ Math.round(axis.y / zoom) }}</div>
    </footer>
</template>

<script>
import { Creator } from '@/lib/visionary/visionary';

export default {
    name: 'FooterComp',
    props: {
        creator: {
            type: Creator,
            required: false
        },
        axis: {
            type: Object,
            required: false
        }
    },
    data() {
        return {}
    },
    computed: {
        zoom() {
            if (!this.$store.state.editor.saveState) return 1;

            return this.$store.state.editor.saveState.zoom || 1;
        }
    }
}
</script>

<style scoped>
.statusbar { display: flex; align-items: center; justify-content: space-between; padding: 0 10px; border-top: 1px solid var(--border); background: var(--panel); color: var(--muted); font-size: 12px; }
.statusbar .left, .statusbar .right { opacity: 0.9; }
</style>
